import React, { useState, useEffect } from 'react'
import EquipmentTypeForm from '../equipment-type-form/EquipmentTypeForm'
import EquipmentService from '../../../../../services/api/equipment.service'
import APIResponse from '../../../../templates/components/APIResponse'

const EditEquipmentType = (props) => {
    const {id,inputChange} = props;
    const [messages, setMessages] = useState({})
    const [isLoaded_form, setIsLoaded_form] = useState(false)
    const [apiResponse,setApiResponse] = useState()


    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.onClose) {
            props.onClose()
        }
    }

    const submitHandler = (data) => {
        // setIsLoader(true)
        const reqObj = {
            equipmentTypeId: data.equipmentTypeId,
            equipmentType: data.equipmentType,
            masterEquipmentTypeId: data.masterEquipmentTypeId,
        }
        EquipmentService.editEquipmentType(reqObj)
            .then(response => {
                setApiResponse(response)
            })
            .catch(error => {
                setApiResponse(error)
            })
    }

    return (
        <div>
           {props.initialData && <EquipmentTypeForm submitHandler={submitHandler} onClose={()=>props.onClose() } initialData={props.initialData} inputChange={inputChange} submitLabel="Update" messages={messages}/>}
           <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true}/>
        </div>
    )
}

export default EditEquipmentType